import qs from "qs";
import { TextFilterModeEnum } from "@exonn/js-sdk";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import {
  ResourceListSearchParams,
  type UrlFilterModel,
} from "src/system/useResourceList.tsx";
import { ListColumnField } from "src/admin/lists/owner-profile/constants.ts";

export const getOwnerProfilesListPath = (id: string) => {
  const filterModel: UrlFilterModel = {
    [ListColumnField.Owner]: {
      v: id,
      o: TextFilterModeEnum.Exact,
    },
  };
  const paths = createModuleRoutePaths({
    resource: ResourceEnum.OwnerProfile,
  });
  return `${paths.root}?${qs.stringify(
    {
      [ResourceListSearchParams.FilterModel]: filterModel,
    },
    {
      encode: false,
    },
  )}`;
};
